import { render, staticRenderFns } from "./TigrosPaymentTypeList.vue?vue&type=template&id=161a65a5"
import script from "./TigrosPaymentTypeList.vue?vue&type=script&lang=js"
export * from "./TigrosPaymentTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports